import React, { useState } from 'react';

import {
  Message,
  Button,
  Radio,
  Container,
  Segment,
  Label,
  Table,
  Icon,
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
} from 'semantic-ui-react';

import _get from 'lodash/get';

import { formatAccountType, getAccountTypeIcon } from './AccountList.utils';

import './AccountList.scss';

function AccountList({ accounts, onAccountSelect }) {
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  function handleSelect(e, { value }) {
    setSelectedAccountId(value);
  }

  function handleSubmit() {
    if (selectedAccountId !== null) {
      onAccountSelect({ gmbAccountId: selectedAccountId });
    }
  }

  if (!accounts) {
    return <Segment attached="bottom" padded="very" loading />;
  }

  if (accounts && !accounts.length) {
    return (
      <Message>
        <Message.Header>Accounts Unavailable</Message.Header>
        <p>We could not find any accounts to link.</p>
      </Message>
    );
  }

  return (
    <Segment attached="bottom" className="account-list">
      <Table selectable singleLine>
        <TableHeader>
          <TableRow>
            <TableHeaderCell width={1}>Select</TableHeaderCell>
            <TableHeaderCell width={6}>Account Owner Name</TableHeaderCell>
            <TableHeaderCell width={3}>Type</TableHeaderCell>
            <TableHeaderCell width={6}>Account ID</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {accounts.map((accountData) => {
            const accountId = _get(accountData, 'accountId', '');
            const accountName = _get(accountData, 'accountName', '');
            const accountType = _get(accountData, 'type', '');

            return (
              <TableRow
                key={accountId}
                onClick={() => handleSelect(null, { value: accountId })}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <Radio
                    name="account"
                    value={accountId}
                    checked={accountId === selectedAccountId}
                    onChange={handleSelect}
                  />
                </TableCell>
                <TableCell>
                  <strong>{accountName}</strong>
                </TableCell>
                <TableCell>
                  {formatAccountType(accountType) && (
                    <Label size="small">
                      <Icon name={getAccountTypeIcon(accountType)} />
                      {formatAccountType(accountType)}
                    </Label>
                  )}
                </TableCell>
                <TableCell>
                  <code style={{ fontSize: '0.9em', color: '#666' }}>{accountId}</code>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Container textAlign="right" style={{ marginTop: '1rem' }}>
        <Button disabled={!selectedAccountId} onClick={handleSubmit} primary>
          Confirm
        </Button>
      </Container>
    </Segment>
  );
}

export default AccountList;
